"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var CommentIndexWrapper = function CommentIndexWrapper(Component) {
  var _class, _class2, _descriptor;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this$props$commentab;
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "showSpinner", _descriptor, _this);
      if ((0, _utils.isBlank)((_this$props$commentab = _this.props.commentable) === null || _this$props$commentab === void 0 ? void 0 : _this$props$commentab.comments)) {
        _this.getComments();
      }
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this$props$commentab2;
        if (prevProps.commentTimestamp !== this.props.commentTimestamp || prevProps.forumThreadId !== this.props.forumThreadId || prevProps.wordId !== this.props.wordId && (0, _utils.isBlank)((_this$props$commentab2 = this.props.commentable) === null || _this$props$commentab2 === void 0 ? void 0 : _this$props$commentab2.comments)) {
          this.getComments();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _state.AppUI.commentStore.setPage(1);
        _state.AppUI.commentStore.clearIndexData();
        _state.ForumUI.onReset();
      }
    }, {
      key: "setCommentOrdering",
      value: function setCommentOrdering(ordering) {
        _state.AppUI.user.set('commentOrdering', ordering);
        _state.AppUI.authUserStore.update({
          data: {
            comment_ordering: ordering
          }
        }, this.afterCommentOrdering);
      }
    }, {
      key: "onUpdateForumThread",
      value: function onUpdateForumThread() {
        _state.ForumUI.loadForumThread(this.props.forumThreadId);
      }
    }, {
      key: "getComments",
      value: function getComments() {
        this.showSpinner = true;
        var forumThreadId = this.props.forumThreadId || _state.ForumUI.forumThreadId;
        var queryStrings = {
          commentable_type: this.props.commentableType,
          forum_thread_id: forumThreadId
        };
        // submitting replies on page 2 is not working (replies show up at the top of page 1)
        // but showing all comments is crashing some mobile devices
        // in the short term, desktop shows all, and mobile paginates but with broken replies
        // it's less of an issue on mobile because Patreon doesn't exist there
        if (!_state.AppUI.layout.isNative) {
          queryStrings['expand_forum'] = true;
        }
        _state.AppUI.commentStore.getIndex({
          queryStrings: queryStrings
        }, this.afterGetComments);
      }
    }, {
      key: "afterGetComments",
      value: function afterGetComments(resp) {
        _state.AppUI.commentStore.setIndexData(resp);
        this.showSpinner = false;
      }
    }, {
      key: "afterCommentOrdering",
      value: function afterCommentOrdering() {
        this.getComments();
      }
    }, {
      key: "comments",
      get: function get() {
        return this.props.commentable && !(0, _utils.isBlank)(this.props.commentable.comments) ? this.props.commentable.comments : _state.AppUI.commentStore.indexData;
      }
    }, {
      key: "latestCommentId",
      get: function get() {
        if (this.comments.length === 0) {
          return null;
        }
        var sortedComments = _toConsumableArray(this.comments).sort(function (a, b) {
          var _a$createdAt, _b$createdAt;
          var aDate = (_a$createdAt = a.createdAt) === null || _a$createdAt === void 0 ? void 0 : _a$createdAt.dateObj;
          var bDate = (_b$createdAt = b.createdAt) === null || _b$createdAt === void 0 ? void 0 : _b$createdAt.dateObj;
          return bDate - aDate;
        });
        return sortedComments[0].id;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          showSpinner: this.showSpinner,
          comments: this.comments,
          setCommentOrdering: this.setCommentOrdering,
          afterCommentOrdering: this.afterCommentOrdering,
          store: _state.AppUI.commentStore,
          onChange: this.getComments,
          onUpdateForumThread: this.onUpdateForumThread,
          latestCommentId: this.latestCommentId
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "setCommentOrdering", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setCommentOrdering"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onUpdateForumThread", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onUpdateForumThread"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getComments", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getComments"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterGetComments", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterGetComments"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterCommentOrdering", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterCommentOrdering"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "comments", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "comments"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "latestCommentId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "latestCommentId"), _class2.prototype), _class2)) || _class;
};
CommentIndexWrapper.displayName = 'CommentIndexWrapper';
var _default = exports["default"] = CommentIndexWrapper;